<!-- N.B. To add map and additional contact details, simply uncomment all content here -->
<template>
<div>
    <div class="container-fluid featured-page-image">
        <div class="feature-header-page">
            <h1>Contact us</h1>
        </div>
    </div>
    <div class="container">
        <div class="row form-heads">
            <div class="col-lg-12 contact-section"> <!-- col-xl-7 -->
                <h2>Submit an Enquiry</h2>
                <hr>
                <p>
                  Please complete the from below and click submit.
                  Spectrum Labels will respond with a quote or get in contact if you wish.
                </p>
                <div v-if="errors.length" class="errors">
                  <p>Please correct the following error(s):</p>
                  <ul>
                    <li v-for="error in errors" :key="error">
                      {{ error }}
                    </li>
                  </ul>
                </div>
                <div v-if="success" class="success">
                  <b>Your message has been sent successfully</b>
                </div>
                <netlify-form name="contact-form">
                    <div class="row">
                        <div class="form-group col-md-6">
                            <label for="first-name">First name</label>
                            <input v-model="firstName" name="firstName" id="first-name" class="form-control" type="text" placeholder="First name" required>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="last-name">Last name</label>
                            <input v-model="lastName" name="lastName" id="last-name" class="form-control" type="text" placeholder="Last name" required>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="email-name">Email</label>
                            <input v-model="email" name="email" id="email-name" class="form-control" type="text" placeholder="Your email" required>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="phone">Phone</label>
                            <input v-model="phone" name="phone" id="phone" class="form-control" type="text" placeholder="Your phone" required>
                        </div>
                        <div class="form-group col-md-12">
                            <label for="message">Your message</label>
                            <textarea v-model="message" name="message" id="message" class="form-control" placeholder="Your message" required></textarea>
                        </div>
                        <div class="form-group col-md-12">
                            <label>GDPR Agreement</label>
                            <div class="row">
                                <div class="checkbox-container" @click="checkboxActive">
                                    <span class="check-box-style" for="checkbox">
                                      <span class="tick"></span>
                                    </span>
                                    <input class="check-box" id="checkbox" v-model="gdpr" type="checkbox" required name="checkbox">
                                    <label for="checkbox" class="check-label" @click="checkboxActive">I consent to having Spectrum Digital Labels Ltd store my submitted information so they can respond to my enquiry.</label>
                                </div>
                            </div>
                            <button type="submit" class="form-button" @click="onSubmit">Submit</button>
                        </div>
                    </div>
                </netlify-form>
            </div>
        </div>
    </div>

  <action-panel></action-panel>
</div>
</template>

<script>
import ActionPanel from '@/components/partials/ActionPanel'
import NetlifyForm from '@/components/forms/NetlifyForm'

export default {
  name: 'ContactUs',
  components: {
    ActionPanel,
    NetlifyForm
  },
  data () {
    return {
      markers: {
        lat: 52.5268689,
        lng: 1.049643
      },
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
      message: null,
      gdpr: false,
      errors: [],
      success: false
    }
  },
  methods: {
    onSubmit (e) {
      this.errors = []
      this.success = false

      if (!this.firstName) {
        this.errors.push('First Name required')
      }
      if (!this.lastName) {
        this.errors.push('Last Name required')
      }
      if (!this.email) {
        this.errors.push('Email required')
      } else if (!this.validEmail(this.email)) {
        this.errors.push('Valid email required')
      }
      if (!this.phone || !this.validPhoneNumber(this.phone)) {
        this.errors.push('Valid phone number required')
      }
      if (!this.message) {
        this.errors.push('Message required')
      }
      if (!this.gdpr) {
        this.errors.push('We are unable to submit your enquiry, without consent to hold your data')
      }
      if (this.errors.length) {
        e.preventDefault()
      }
    },
    validEmail: function (email) {
      // eslint-disable-next-line
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    validPhoneNumber: function (phoneNumber) {
      phoneNumber = phoneNumber.replace(/[()]+/g, '')
      let number = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/
      return number.test(phoneNumber)
    },
    checkboxActive () {
      const checkboxStyle = document.querySelector('.check-box-style')
      checkboxStyle.classList.toggle('active')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/ContactUs.vue